import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavService, UxService } from '~/app/core/services';
import { LogListComponent } from '~/app/open-age-ng/insight/log-list/log-list.component';
import { Link } from '~/app/open-age/core/structures';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css']
})
export class LogsComponent implements OnInit {

  @ViewChild('details')
  details: LogListComponent;

  isCurrent = true;
  page: Link;
  message: string;

  constructor(
    private navService: NavService,
    private errorHandler: UxService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.page = this.navService.register(`/log/list`, this.route, (isCurrent, params) => {
      this.isCurrent = isCurrent;
    });
  }

  onViewed(item) {
    this.navService.goto(`/log/list/${item.id}`)
  }

  onReset() {
    this.message = null
    this.details.fetch()
  }

}
